import { render, staticRenderFns } from "./message-square.vue?vue&type=template&id=c7ef175a&"
import script from "./message-square.vue?vue&type=script&lang=js&"
export * from "./message-square.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7ef175a')) {
      api.createRecord('c7ef175a', component.options)
    } else {
      api.reload('c7ef175a', component.options)
    }
    module.hot.accept("./message-square.vue?vue&type=template&id=c7ef175a&", function () {
      api.rerender('c7ef175a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/message-square.vue"
export default component.exports